module.exports = __webpack_public_path__ + "75f0f675d3d35226a90bae413197f85c.png";